<template>
    <div>
        <div style="padding: 12px 24px 12px 24px" v-if="layout.children.length > 0">
            <Container
                v-for="row in layout.children"
                :key="row.id"
                :id="'dragContainer_' + row.id"
                :class="[
                    $bp.smallScreen ? 'db-layout-column' : 'db-layout',
                    dashboard_arranging_widgets ? 'drag-border dndrop-container horizontal' : 'dndrop-container horizontal',
                    'row',
                ]"
                @drop="(e) => onDrop(row.id, e)"
                @drag-start="onDragStart"
                @drag-enter="dragEnter(row.id)"
                @drag-leave="dragLeave(row.id)"
                @drag-end="dragLeave(row.id)"
                :fire-related-events-only="true"
                :get-child-payload="getWidgetPayload(row.id)"
                :drag-begin-delay="dashboard_arranging_widgets ? 0 : 500"
                :widget-row="row.id"
                group-name="row"
                drag-handle-selector=".app-card-title"
                wrap
                orientation="horizontal"
                style="min-height: 550px"
            >
                <Draggable
                    v-for="widget in row.children"
                    v-if="current_user.global.indexOf(`${widget.permission}`) > -1"
                    :key="widget.id"
                    :class="['flex', $bp.smallScreen ? '' : `db${widget.column_span}`]"
                    :column_span="widget.column_span"
                    :drag-not-allowed="$bp.smallScreen ? true : false"
                >
                    <component :ref="widget.name" :is="widget.name" :widget-name="widget.name"></component>
                </Draggable>
            </Container>
            <div
                class="dashboard-arrange"
                v-if="dashboard_arranging_widgets == true"
                style="right: 0; bottom: 0; position: fixed; top: 50%; height: 90px; width: 60px"
            >
                <bc-tooltip left>
                    <template slot="activator">
                        <div
                            class="dashboard-add-row"
                            style="height: 45px; position: absolute; text-align: center; width: 45px; padding: 5px"
                            @click="dropNotAllowed()"
                        >
                            <v-icon ti-plus style="width: 32px; height: 32px">ti-plus</v-icon>
                        </div>
                    </template>
                    Add Row
                </bc-tooltip>
                <bc-tooltip left>
                    <template slot="activator">
                        <div
                            class="dashboard-modify-widget-visibility"
                            style="height: 45px; position: absolute; text-align: center; width: 45px; top: 45px; padding: 5px"
                            @click="openShowAndHideWidgets()"
                        >
                            <v-icon ti-eye style="width: 32px; height: 32px">ti-eye</v-icon>
                        </div>
                    </template>
                    Show/Hide Widgets
                </bc-tooltip>
                <bc-tooltip left>
                    <template slot="activator">
                        <div
                            class="dashboard-arrange-done"
                            style="height: 45px; position: absolute; text-align: center; width: 45px; top: 90px; padding: 5px"
                            @click="updateLayout()"
                        >
                            <v-icon ti-check style="width: 32px; height: 32px">ti-check</v-icon>
                        </div>
                    </template>
                    Save Layout
                </bc-tooltip>
                <bc-tooltip left>
                    <template slot="activator">
                        <div
                            class="dashboard-cancel-edit"
                            style="height: 45px; position: absolute; text-align: center; width: 45px; padding: 5px; top: 135px"
                            @click="cancelEdit()"
                        >
                            <v-icon ti-close style="width: 32px; height: 32px">ti-close</v-icon>
                        </div>
                    </template>
                    Cancel
                </bc-tooltip>
            </div>
        </div>
        <div style="height: calc(100vh - 64px)" class="d-flex" v-else>
            <v-flex xs12 class="d-flex text-center align-content-center align-items-center justify-center">
                <v-btn round style="max-width: 192px" large color="primary" @click="openShowAndHideWidgets">{{ $t("lang.configure_widgets") }}</v-btn>
            </v-flex>
        </div>

        <bc-dialog :value="showAndHideWidgets" max-width="700">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.configure_widgets") }}</span>
                    <v-spacer></v-spacer>
                    <!-- <bc-btn-refresh @invoke-method="getportHistory()"></bc-btn-refresh> -->
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="showAndHideWidgets"
                        :dialog-status="showAndHideWidgets"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <!-- signal chart goes here -->
                <v-card-text pa-0>
                    <v-container pa-0>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-data-table
                                    :headers="widget_headers"
                                    :items="filterDashboardWidgets() || []"
                                    :no-data-text="$t('lang.no_data_available')"
                                    hide-actions
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td class="text-center">
                                                <v-checkbox
                                                    hide-details
                                                    :input-value="shown_widgets.indexOf(props.item.name) > -1 ? true : false"
                                                    @change="changeWidgetVisibility($event, props.item)"
                                                    class="justify-center"
                                                ></v-checkbox>
                                            </td>
                                            <td>
                                                {{ props.item.name_alias }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="showAndHideWidgets = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="modifyShowAndHideWidgets">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { testWidgets } from "./data";
import { Container, Draggable } from "vue-dndrop";
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import Vue from "vue";

// import Widgets from "./Ecommerce copy.vue";
import WorkOrders from "Modules/dashboard/components/Widgets/WidgetWorkOrders.vue";
import Subscriptions from "Modules/dashboard/components/Widgets/WidgetSubscriptions.vue";
import OfflineDevices from "Modules/dashboard/components/Widgets/WidgetOfflineDevices.vue";
// import RecentDataSessions from "Modules/dashboard/components/Widgets/WidgetRecentDataSessions.vue";
import RecentNotifications from "Modules/dashboard/components/Widgets/WidgetRecentNotifications.vue";
import WeeklySales from "Modules/dashboard/components/Widgets/WidgetWeeklySales.vue";
import DeviceAlerts from "Modules/dashboard/components/Widgets/WidgetDeviceAlerts.vue";

export default {
    name: "Groups",
    components: {
        Container,
        Draggable,
        work_orders: WorkOrders,
        subscriptions: Subscriptions,
        offline_devices: OfflineDevices,
        // recent_data_sessions: RecentDataSessions,
        recent_notifications: RecentNotifications,
        weekly_sales: WeeklySales,
        device_alerts: DeviceAlerts,
    },
    data() {
        return {
            layout: { children: [] },
            show: true,
            originalLayout: {},
            checkColSpan: false,
            itFits: true,
            tmpLayout: {},
            countEvents: 0,
            showAndHideWidgets: false,
            widget_headers: [
                { text: "Show/Hide", width: "3%", sortable: false, align: "center" },
                { text: this.$t("lang.widget_name"), sortable: false, width: "25%" },
            ],
            shown_widgets: [],
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (!vm.currUserField("user_id")) vm.store.commit("logoutUser", { returnToLogin: true });

            if (vm.currUserField("dashboard_layout")) {
                vm.setLayout();
            }
            vm.finishLoader();
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.finishLoader();
        next();
    },
    beforeRouteLeave(to, from, next) {
        // called when the route that renders this component is about to be navigated away from.
        // check if layout needs updated on leave
        this.updateLayout(this.layout);
        localStorage.removeItem("dashboard_original_layout");

        next();
    },
    computed: {
        ...mapState({
            dashboard_arranging_widgets: (state) => state.settings.dashboard_arranging_widgets,
            dashboard_widgets: (state) => state.dashboard_widgets.dashboard_widget_options,
        }),
    },
    methods: {
        ...mapActions(["fetchDashboardWidgets"]),
        onDrop(index, dropResult) {
            // https://github.com/amendx/vue-dndrop
            const { removedIndex, addedIndex, payload, element } = dropResult;
            let scene = Object.assign({}, this.layout);
            let row = scene.children.filter((p) => p.id === index)[0];
            let rowIndex = scene.children.indexOf(row);
            let rowObj = Object.assign({}, row);

            if (removedIndex !== null || addedIndex !== null) {
                this.countEvents++;

                if (removedIndex !== null && addedIndex !== null) {
                    rowObj.children = this.applyDrag(rowObj.children, dropResult);

                    if (rowObj.children.length > 0) {
                        scene.children.splice(rowIndex, 1, rowObj);
                    } else if (rowObj.children.length == 0) {
                        scene.children.splice(rowIndex, 1);
                    }

                    //this.itFits = true;
                    this.layout = Object.assign({}, scene);
                    localStorage.setItem("dashboard_layout", JSON.stringify(this.layout));
                    this.countEvents = 0;

                    // UPDATE DATABASE
                } else {
                    let totalColSpan = 0;
                    for (let child in rowObj.children) {
                        totalColSpan += parseInt(rowObj.children[child].column_span);
                    }
                    if ((totalColSpan + parseInt(payload.column_span) > 12 && addedIndex !== null) || (totalColSpan > 12 && removedIndex !== null)) {
                        this.itFits = false;
                    }

                    rowObj.children = this.applyDrag(rowObj.children, dropResult);

                    if (rowObj.children.length > 0) {
                        scene.children.splice(rowIndex, 1, rowObj);
                    } else if (rowObj.children.length == 0) {
                        scene.children.splice(rowIndex, 1);
                    }

                    if (this.countEvents == 2) {
                        if (this.itFits == true) {
                            this.layout = scene;
                            localStorage.setItem("dashboard_layout", JSON.stringify(this.layout));
                        } else {
                            this.layout = JSON.parse(localStorage.getItem("dashboard_layout"));
                        }

                        // RESET VARIABLES
                        this.itFits = true;
                        this.countEvents = 0;
                    }
                }
            }
        },
        onDragStart() {
            if (!this.dashboard_arranging_widgets == true) {
                this.$store.commit("commitSetting", {
                    property: "dashboard_arranging_widgets",
                    with: true,
                });
            }
        },
        dropNotAllowed() {
            let lastChild = this.layout.children[this.layout.children.length - 1];
            this.layout.children.push({
                id: parseInt(lastChild["id"]) + 1,
                type: "container",
                children: [],
            });
        },
        applyDrag(arr, dragResult) {
            const { removedIndex, addedIndex, payload } = dragResult;
            if (removedIndex === null && addedIndex === null) return arr;

            let result = [...arr];
            let itemToAdd = payload;

            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0];
            }

            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd);
            }

            result = result.map(function (item, index) {
                item["id"] = index;
                return item;
            });
            return result;
        },
        getWidgetPayload(widgetId) {
            return (index) => {
                return this.layout.children.filter((p) => p.id === widgetId)[0].children[index];
            };
        },
        dragEnter(container) {
            const dragContainer = document.getElementById(`dragContainer_${container}`);
            dragContainer.classList.add("active-drag-container");
        },
        dragLeave(container) {
            const dragContainer = document.getElementById(`dragContainer_${container}`);
            dragContainer.classList.remove("active-drag-container");
        },
        cancelEdit() {
            this.layout = JSON.parse(localStorage.getItem("dashboard_original_layout"));
            if (this.dashboard_arranging_widgets == true) {
                this.$store.commit("commitSetting", {
                    property: "dashboard_arranging_widgets",
                    with: false,
                });
            }
        },
        updateLayout() {
            if (!this.currUserField("user_id")) return;

            var i = this.layout.children.length;
            while (i--) {
                if (this.layout.children[i].children.length == 0) {
                    this.layout.children.splice(i, 1);
                }
            }
            this.$store
                .dispatch("fetchUsers", {
                    url: `users/${this.currUserField("user_id")}`,
                    method: "patch",
                    body: {
                        dashboard_layout: JSON.stringify(this.layout),
                    },
                    headers: { "X-SILENT": "1" },
                })
                .then((data) => {
                    this.$store.commit("updateUser", data.users);
                    this.setLayout();
                    this.$store.commit("commitSetting", {
                        property: "dashboard_arranging_widgets",
                        with: false,
                    });
                });
        },
        setLayout() {
            if (!this.currUserField("user_id")) return;

            this.$store
                .dispatch("fetchUsers", {
                    url: `users/${this.currUserField("user_id")}`,
                    method: "get",
                    headers: { "X-SILENT": "1" },
                })
                .then((data) => {
                    if (data.user.dashboard_layout != null) {
                        let dashboard_layout = data.user.dashboard_layout;
                        for (let i = 0; i < dashboard_layout.children.length; i++) {
                            let row = dashboard_layout.children[i];
                            for (let j = 0; j < row.children.length; j++) {
                                let widget_in_row = row.children[j];
                                if (this.current_user.global.indexOf(widget_in_row.permission) <= -1) {
                                    row.children.splice(j, 1);
                                    j--;
                                }
                            }
                            if (row.children.length == 0) {
                                dashboard_layout.children.splice(i, 1);
                                i--;
                            }
                        }
                    }
                    data.user.dashboard_layout != null
                        ? localStorage.setItem("dashboard_original_layout", JSON.stringify(data.user.dashboard_layout))
                        : localStorage.setItem("dashboard_original_layout", JSON.stringify({ children: [] }));
                    data.user.dashboard_layout != null
                        ? localStorage.setItem("dashboard_layout", JSON.stringify(data.user.dashboard_layout))
                        : localStorage.setItem("dashboard_layout", JSON.stringify({ children: [] }));
                    data.user.dashboard_layout != null ? (this.layout = Object.assign({}, data.user.dashboard_layout)) : (this.layout = { children: [] });
                    this.$store.commit("commitSetting", {
                        property: "dashboard_arranging_widgets",
                        with: false,
                    });
                });
        },
        openShowAndHideWidgets() {
            this.shown_widgets = [];
            this.fetchDashboardWidgets({ body: { options: 1 } }).then((data) => {
                //find in the dashboard_layout from localStorage the widgets that have the same id as in the available widgets
                //and set the visibility to true

                // Check the current dashboard_layout from localStorage and iterate through the this.dashboard_widgets
                // and set the visibility to true or false based on the dashboard_layout
                let dashboard_layout = JSON.parse(localStorage.getItem("dashboard_layout"));
                let dashboard_widgets = this.dashboard_widgets;
                if (dashboard_layout.children.length > 0) {
                    for (let i = 0; i < dashboard_widgets.length; i++) {
                        let widget = dashboard_widgets[i];
                        let widget_name = widget.name;
                        for (let j = 0; j < dashboard_layout.children.length; j++) {
                            let row = dashboard_layout.children[j];
                            for (let k = 0; k < row.children.length; k++) {
                                let widget_in_row = row.children[k];
                                if (widget_in_row.name == widget_name) {
                                    this.shown_widgets.push(widget_in_row.name);
                                    break;
                                }
                            }
                        }
                    }
                }

                this.showAndHideWidgets = true;
            });
        },
        modifyShowAndHideWidgets() {
            // Iterate through this.dashboard_widgets and use this.shown_widgets to modify the dashboard_layout from localStorage
            // if the dashboard_layout already has widgets calculate the column_span and add the widget to the row if the
            // column_span is less than 12 with the new widget span added in. If the column_span is greater than 12 move to the next row,
            // if all rows are full add a new row and add the widget to the new row.
            // if the dashboard_layout doesn't have widgets add the widget to the first row.
            let dashboard_layout = JSON.parse(localStorage.getItem("dashboard_layout"));
            let dashboard_widgets = this.dashboard_widgets;
            let shown_widgets = this.shown_widgets;
            let widget_added = false;
            for (let i = 0; i < dashboard_widgets.length; i++) {
                let widget = dashboard_widgets[i];
                let widget_name = widget.name;
                let widget_column_span = widget.column_span;
                let widget_added = false;

                if (shown_widgets.indexOf(widget_name) > -1) {
                    for (let j = 0; j < dashboard_layout.children.length; j++) {
                        let row = dashboard_layout.children[j];
                        let row_column_span = 0;
                        for (let k = 0; k < row.children.length; k++) {
                            let widget_in_row = row.children[k];
                            row_column_span += parseInt(widget_in_row.column_span);
                            if (widget_in_row.name == widget_name) {
                                widget_added = true;
                                continue;
                            }
                        }
                        if (widget_added == false) {
                            if (row_column_span + parseInt(widget_column_span) <= 12) {
                                // add widget to row
                                row.children.push({
                                    id: row.children.length + 1,
                                    column_span: widget_column_span,
                                    name: widget_name,
                                    permission: widget.permission,
                                });
                                widget_added = true;
                                row.children = row.children.map(function (item, index) {
                                    item["id"] = index;
                                    return item;
                                });
                                continue;
                            }
                        }
                    }
                    if (widget_added == false) {
                        // add widget to new row
                        dashboard_layout.children.push({
                            id: dashboard_layout.children.length + 1,
                            type: "container",
                            children: [
                                {
                                    id: 0,
                                    name: widget_name,
                                    column_span: widget_column_span,
                                    permission: widget.permission,
                                },
                            ],
                        });
                    }
                }
            }

            // if the widget is not in the shown_widgets array remove it from the dashboard_layout
            for (let i = 0; i < dashboard_layout.children.length; i++) {
                let row = dashboard_layout.children[i];
                for (let j = 0; j < row.children.length; j++) {
                    let widget_in_row = row.children[j];
                    if (this.shown_widgets.indexOf(widget_in_row.name) <= -1) {
                        row.children.splice(j, 1);
                        j--;
                    }
                }
            }
            dashboard_layout.children = dashboard_layout.children.map(function (item, index) {
                item["id"] = index;
                return item;
            });
            localStorage.setItem("dashboard_layout", JSON.stringify(dashboard_layout));
            this.layout = dashboard_layout;
            this.showAndHideWidgets = false;
            this.updateLayout();
        },
        changeWidgetVisibility($event, widget) {
            if (this.shown_widgets.indexOf(widget.name) > -1 && $event == false) {
                // remove widget from shown_widgets
                this.shown_widgets.splice(this.shown_widgets.indexOf(widget.name), 1);
            } else if (this.shown_widgets.indexOf(widget.name) <= -1 && $event == true) {
                this.shown_widgets.push(widget.name);
            }
        },
        filterDashboardWidgets() {
            // Iterate through this.dashboard_widgets and if the permission is in the current_user.global array
            // add it to the filtered array
            let filtered_widgets = [];
            for (let i = 0; i < this.dashboard_widgets.length; i++) {
                let widget = this.dashboard_widgets[i];
                if (this.current_user.global.indexOf(widget.permission) > -1) {
                    filtered_widgets.push(widget);
                }
            }
            return filtered_widgets;
        },
    },
    mounted() {},
    beforeRouteLeave(to, from, next) {
        this.$store.commit("setPageNotifications", {});
        next();
    },
};
</script>
<style lang="css" scoped>
.db-layout,
.db-layout-column {
    display: flex !important;
    flex: 1 1 auto;
    flex-wrap: nowrap;
    min-width: 0;
    margin-left: -12px;
    margin-right: -12px;
}
.db-layout.wrap {
    flex-wrap: wrap;
}
.db-layout.row {
    flex-direction: row;
}
.db-layout.wrap {
    flex-wrap: wrap;
}
.db-layout-column.row {
    flex-direction: column;
}
.dndrop-draggable-wrapper {
    padding: 12px;
}
.flex .flex:not(.animation) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
}
.flex.db1 {
    flex-basis: 8.333333333333332%;
    flex-grow: 0;
    max-width: 8.333333333333332%;
}
.flex.db2 {
    flex-basis: 16.666666666666664%;
    flex-grow: 0;
    max-width: 16.666666666666664%;
}
.flex.db3 {
    flex-basis: 25%;
    flex-grow: 0;
    max-width: 25%;
}
.flex.db4 {
    flex-basis: 33.33333333333333%;
    flex-grow: 0;
    max-width: 33.33333333333333%;
}
.flex.db5 {
    flex-basis: 41.66666666666667%;
    flex-grow: 0;
    max-width: 41.66666666666667%;
}
.flex.db6 {
    flex-basis: 50%;
    flex-grow: 0;
    max-width: 50%;
}
.flex.db7 {
    flex-basis: 58.333333333333336%;
    flex-grow: 0;
    max-width: 58.333333333333336%;
}
.flex.db8 {
    flex-basis: 66.66666666666666%;
    flex-grow: 0;
    max-width: 66.66666666666666%;
}
.flex.db9 {
    flex-basis: 75%;
    flex-grow: 0;
    max-width: 75%;
}
.flex.db10 {
    flex-basis: 83.33333333333334%;
    flex-grow: 0;
    max-width: 83.33333333333334%;
}
.flex.db11 {
    flex-basis: 91.66666666666666%;
    flex-grow: 0;
    max-width: 91.66666666666666%;
}
.flex.db12 {
    flex-basis: 100%;
    flex-grow: 0;
    max-width: 100%;
}
.draggable-item-horizontal {
    padding: 20px;
    border: 2px solid black;
    margin: 10px;
}
.groups {
    display: flex;
    flex-direction: column;
}
.drag-border {
    padding: 5px;
    margin: 5px;
    border: 2px dashed darkgray !important;
}

.v-icon {
    font-size: 16px !important;
}

.dashboard-add-row > i {
    color: white;
    border-radius: 50%;
    background: #3aa5f9;
    padding: 5px;
}

.dashboard-arrange-done > i {
    color: white;
    border-radius: 50%;
    background: #41d013;
    padding: 5px;
}

.dashboard-cancel-edit > i {
    color: white;
    border-radius: 50%;
    background: #ff383a;
    padding: 5px;
}
.dashboard-modify-widget-visibility > i {
    color: white;
    border-radius: 50%;
    background: #ffb710;
    padding: 5px;
}

.dashboard-add-row,
.dashboard-arrange-done,
.dashboard-cancel-edit,
.dashboard-modify-widget-visibility {
    background: #ffffff;
}

.dashboard-add-row > i:hover,
.dashboard-arrange-done > i:hover,
.dashboard-cancel-edit > i:hover,
.dashboard-modify-widget-visibility > i:hover {
    cursor: pointer;
    filter: brightness(110%);
}

.dashboard-arrange {
    box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
}

.active-drag-container {
    border: 2px dashed black !important;
}
</style>
